import React, { useEffect } from 'react';
import Create from './Create';
import { useDispatch } from 'react-redux';
import { toggleCreateAssetView } from '../../redux/actions/createAssetViewActions';
import { addAssets, setCreateJiraTicket } from '../../redux/actions/assetsAction';
import { Asset } from '../../Utils/AssetUtils';

// Manual entry layout view which calls reusable Create component under the hood.
const ManualEntryLayout = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		// setting the state to keep track of Manual Entry view (used in the reusable components) is active.
		dispatch(toggleCreateAssetView(false));
		// set Jira ticket checkbox false on manual entry.
		dispatch(setCreateJiraTicket(false));
		// Adding one default asset container when user lands on Manual Entry page. setting isAddedBySystem field as true, since it is added by the UI.
		const asset = new Asset(1, '', true);
		dispatch(addAssets([asset]));
	}, [dispatch]);
	return <Create></Create>;
};

export default ManualEntryLayout;
